(function () {
  var root = document.querySelector('[data-cba-body]');
  if (!root || root.getAttribute('data-cba-ready')) return;
  root.setAttribute('data-cba-ready', '1');

  var reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;
  var tocCards = root.querySelectorAll('[data-cba-toc]');
  var tocLists = root.querySelectorAll('[data-cba-toc-list]');
  var rte = root.querySelector('[data-cba-rte]');
  var stickyAtc = root.querySelector('[data-cba-sticky-atc]');
  var stickyClose = root.querySelector('[data-cba-sticky-close]');
  var stickyDismissed = false;
  var tocLinkMap = new Map();
  var visibleIds = new Set();
  var activeId = null;
  var observer = null;
  var raf = null;

  function slugify(text) {
    return String(text)
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildToc() {
    if (!rte) return [];
    var headings = rte.querySelectorAll('h2');
    if (!headings.length) return [];

    var used = new Set();
    var items = [];

    headings.forEach(function (heading, index) {
      var label = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (!label) return;

      var base = heading.id || slugify(label) || 'section-' + (index + 1);
      var id = base;
      var n = 1;
      while (
        used.has(id) ||
        (heading.id !== id && document.getElementById(id))
      ) {
        n += 1;
        id = base + '-' + n;
      }
      heading.id = id;
      used.add(id);
      items.push({ id: id, label: label });
    });

    return items;
  }

  function renderToc(items) {
    if (!items.length) {
      tocCards.forEach(function (card) {
        card.setAttribute('hidden', '');
      });
      return;
    }

    var html = items
      .map(function (item) {
        return (
          '<li class="cba-toc__item">' +
          '<a class="cba-toc__link" href="#' +
          escapeHtml(item.id) +
          '" data-cba-toc-link data-cba-toc-target="' +
          escapeHtml(item.id) +
          '">' +
          '<span class="cba-toc__icon" aria-hidden="true"></span>' +
          '<span class="cba-toc__label">' +
          escapeHtml(item.label) +
          '</span></a></li>'
        );
      })
      .join('');

    tocLists.forEach(function (list) {
      list.innerHTML = html;
    });
    tocCards.forEach(function (card) {
      card.removeAttribute('hidden');
    });
  }

  function collectLinks() {
    tocLinkMap.clear();
    root.querySelectorAll('[data-cba-toc-link]').forEach(function (link) {
      var id = link.getAttribute('data-cba-toc-target');
      if (!id) return;
      if (!tocLinkMap.has(id)) tocLinkMap.set(id, []);
      tocLinkMap.get(id).push(link);
      link.addEventListener('click', function (event) {
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });
        if (history && history.replaceState)
          history.replaceState(null, '', '#' + id);
        if (target.tabIndex < 0) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  function setActive(id) {
    tocLinkMap.forEach(function (links, key) {
      links.forEach(function (link) {
        if (key === id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    });
    activeId = id;
  }

  function observeHeadings(items) {
    if (typeof IntersectionObserver === 'undefined') return;
    var nodes = items
      .map(function (item) {
        return document.getElementById(item.id);
      })
      .filter(Boolean);
    if (!nodes.length) return;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visibleIds.add(entry.target.id);
          else visibleIds.delete(entry.target.id);
        });
        var next = items
          .map(function (item) {
            return item.id;
          })
          .find(function (id) {
            return visibleIds.has(id);
          });
        if (next && next !== activeId) setActive(next);
      },
      { rootMargin: '-20% 0px -65% 0px', threshold: [0, 1] },
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function updateStickyAtc() {
    if (!stickyAtc || !rte || stickyDismissed) return;
    if (window.matchMedia('(min-width: 1024px)').matches) {
      stickyAtc.classList.remove('is-visible');
      return;
    }
    var rect = rte.getBoundingClientRect();
    if (rect.top <= 0 && rect.bottom > 0) stickyAtc.classList.add('is-visible');
    else stickyAtc.classList.remove('is-visible');
  }

  function onScrollOrResize() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      updateStickyAtc();
    });
  }

  var items = buildToc();
  renderToc(items);
  if (items.length) {
    collectLinks();
    observeHeadings(items);
    var hash = window.location.hash;
    if (hash && hash.length > 1) {
      var el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el)
        requestAnimationFrame(function () {
          el.scrollIntoView({ behavior: 'auto', block: 'start' });
        });
    }
  }

  if (stickyAtc && rte) {
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    updateStickyAtc();
  }

  if (stickyClose) {
    stickyClose.addEventListener('click', function () {
      stickyDismissed = true;
      stickyAtc.classList.remove('is-visible');
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
    });
  }
})();
